import script from "./noticeList.vue?vue&type=script&setup=true&name=noticeList&lang=js"
export * from "./noticeList.vue?vue&type=script&setup=true&name=noticeList&lang=js"

const __exports__ = script;

export default __exports__